// extracted by mini-css-extract-plugin
export default {"ul":"PostList_ul__grXMZ"};